import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { SOLUTION_AFTER, SOLUTION_BEFORE } from './salesData';

/** Solución: dejar de improvisar y tener el mensaje preparado para cada etapa. */
export function SolutionSection() {
  return <section className="w-full bg-ink py-16 text-white sm:py-20" data-id="element-186" data-mp="3j9ft97qwokem">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-6" data-id="element-187" data-mp="142rxhpax502">
        <div className="max-w-2xl" data-id="element-188" data-mp="12hvfmjffbzk">
          <SectionTag tone="dark" data-id="element-189" data-mp="3t8wwliioqm7f">La solución</SectionTag>
          <h2 className="mt-4 font-display text-[1.85rem] font-extrabold leading-tight sm:text-[2.4rem]" data-id="element-190" data-mp="3t6aqzofcugru">
            Dejá de improvisar cada respuesta
          </h2>
          <p className="mt-3 font-sans text-[1.02rem] leading-relaxed text-white/65" data-id="element-191" data-mp="5wm5ienzo04v">
            Una venta por WhatsApp siempre pasa por las mismas etapas. Con el mensaje
            preparado para cada una, la conversación avanza en vez de morirse.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-192" data-mp="36bdwypikchqj">
          <div className="rounded-2xl border border-graphite-line bg-graphite p-5 sm:p-6" data-id="element-193" data-mp="36cyrwg8si2ox">
            <h3 className="font-display text-[0.72rem] font-bold uppercase tracking-editorial text-white/45" data-id="element-194" data-mp="3bbt8rcn75h6e">
              Improvisando
            </h3>
            <ul className="mt-4 flex flex-col gap-3" data-id="element-195" data-mp="3kana1gbh2vqa">
              {SOLUTION_BEFORE.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-196" data-mp="3p8f52j7eyxyp">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-white/35" aria-hidden strokeWidth={2.5} data-id="element-197" data-mp="3u8ba8lrukvfu" />
                  <span className="font-sans text-[0.92rem] leading-snug text-white/55" data-id="element-198" data-mp="6vhakrte4xbx">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-wa/40 bg-graphite p-5 sm:p-6" data-id="element-199" data-mp="gtexnbziko2y">
            <h3 className="font-display text-[0.72rem] font-bold uppercase tracking-editorial text-wa" data-id="element-200" data-mp="grbwbvswv8ix">
              Con los 100 scripts
            </h3>
            <ul className="mt-4 flex flex-col gap-3" data-id="element-201" data-mp="27z1bup1kq2z6">
              {SOLUTION_AFTER.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-202" data-mp="2mne9rrk81vwb">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-wa" aria-hidden strokeWidth={3} data-id="element-203" data-mp="2hve3lhdk66ra" />
                  <span className="font-sans text-[0.92rem] leading-snug text-white" data-id="element-204" data-mp="2rlphnwqyhwbw">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-205" data-mp="30lvr97jjac5s">
          <CTAButton label="QUIERO LOS MENSAJES LISTOS" data-id="element-206" data-mp="30kaztqsin9c5" />
        </div>
      </div>
    </section>;
}